import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MonedaFormGroup = ({ iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='input-moneda' md={12} />
      <Col md={12}>
        <Field name='moneda'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled id='input-moneda' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
